// Haptic feedback utility
export const triggerHapticFeedback = (type: 'error' | 'success' | 'warning') => {
  if (!window.navigator || !window.navigator.vibrate) {
    return; // Device doesn't support vibration
  }
  
  switch (type) {
    case 'error':
      // Strong error vibration pattern - 2 pulses
      window.navigator.vibrate([100, 50, 100]);
      break;
    case 'success':
      // Single short vibration for success
      window.navigator.vibrate(50);
      break;
    case 'warning':
      // Medium vibration for warnings
      window.navigator.vibrate(80);
      break;
    default:
      break;
  }
};
